import { RECEIPTS } from '../actionTypes';

export const fetchReceipts = (action) => ({
  type: RECEIPTS.FETCH,
  payload: action.payload,
});
